<rt-icon class="icon" name="error" />
<span class="label">{{
  'tlc.tellent_assistant.tool_call.render_error' | translate: { name: toolName() }
}}</span>
